export const SET_AUTH_USER         = 'SET_AUTH_USER';
export const SET_AUTH_USER_LINK    = 'SET_AUTH_USER_LINK';
export const REMOVE_AUTH_USER      = 'REMOVE_AUTH_USER';
export const REMOVE_AUTH_USER_LINK = 'REMOVE_AUTH_USER_LINK';
